import React from "react";
import "./App.css"; // Import the CSS file for styling


function DomesticFamilyLaw(){

    return <div>

         <img src="/family.jpg" alt="Header" />

<h2>Divorce & Family Law</h2>



    </div>;


}




export default DomesticFamilyLaw;